import React from 'react';
import { Info } from 'lucide-react';
import { cardSurfaceClass, cx, resolveLegendDotClass } from '../theme';

export default function DomainLegend({ legend, alert }) {
  return (
    <section className={cx(cardSurfaceClass, 'flex flex-wrap items-center gap-4 px-4 py-3')}>
      <span data-coo="legend-label" className="text-[11px] font-bold uppercase tracking-[0.08em] text-slate-500">
        {legend.label}
      </span>
      {legend.items.map((item) => (
        <div key={item.label} data-coo="legend-item" className="flex items-center gap-2 text-[12px] font-medium text-slate-600">
          <span className={`h-2.5 w-2.5 rounded-full ${resolveLegendDotClass(item.label)}`} />
          <span>{item.label}</span>
        </div>
      ))}
      <div className="ml-auto flex items-center gap-3">
        <div data-coo="legend-note" className="text-[11px] text-slate-500">
          {legend.note}
        </div>
        {alert ? (
          <div className="group relative">
            <button
              type="button"
              aria-label={`${alert.label} ${alert.text}`}
              title={`${alert.label} ${alert.text}`}
              className="inline-flex h-8 w-8 items-center justify-center rounded-full border border-slate-200 bg-white text-slate-500 transition hover:border-slate-300 hover:text-slate-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-slate-300"
            >
              <Info className="h-4 w-4" />
            </button>
            <div className="pointer-events-none absolute right-0 top-10 z-20 invisible w-80 rounded-2xl border border-slate-200 bg-white p-3 opacity-0 shadow-[0_14px_32px_rgba(15,23,42,0.12)] transition group-hover:visible group-hover:opacity-100 group-focus-within:visible group-focus-within:opacity-100">
              <div data-coo="alert-label" className="text-[11px] font-semibold uppercase tracking-[0.08em] text-amber-700">
                {alert.label}
              </div>
              <div data-coo="alert-text" className="mt-1 text-[12px] leading-5 text-slate-600">
                {alert.text}
              </div>
            </div>
          </div>
        ) : null}
      </div>
    </section>
  );
}
